import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { ESTILO_BOTON_MODAL_ACEPTAR } from "../../../utils/const/estilos-const";
// import ModalConfirmar from "../../../components/modal-confirmar";
import "../../../style/style-cargando.css";
import cargandoCard from "../../../components/cargando-card";
import sinAccesoCard from "../../../components/sin-acceso-card";
// import { Settings } from "feather-icons-react/build/IconComponents";
// import { sharedNextPage } from "../../../utils/shared-functions";
// import { SELECT_HABILITADO_DESHABILITADO } from "../../../utils/const/const-select-habilitado-deshabilitado";
// import Select from "react-select";
// import ArrowBack from "../../../components/arrow-back";
import { useTranslation } from "react-i18next";
// import { COLOR_VERDE_MAIN } from "../../../utils/const/colors-const";
import ProcessingDialog from "../../../components/processing-dialog";
import ToastComponent from "../../../components/toast-component";
import ProductosModal from "../../../components/productos-modal";
import WorkflowModal from "../../../components/workflow-modal";
import ModalMapaSeguimiento from "../../../components/modal-mapa-seguimiento";
// import { deshabilitarCliente, habilitarCliente, obtenerListaCliente } from "../../../api/api-cliente";
import Calendar from "../../../components/calendar";
import moment from "moment";
import { obtenerListaDetallePedido } from "../../../api/api-detalle-pedido";
import { STRING_ID_TIPO_USUARIO_WEB, STRING_SUPER_ADMIN, STRING_ID_ROL_USUARIO_WEB } from "../../../utils/const/string-const";
import { obtenerPermisoRolUsuarioWeb } from "../../../api/api-permiso-rol-usuario-web";
import { PAGE_ID } from "../../usuarios/gestionar-rol-usuario-web/pages-const";

// let $ = window.$;

export default function ListaSeguimientoPage
  () {
  const idTipoUsuarioWeb = localStorage.getItem(STRING_ID_TIPO_USUARIO_WEB);
  const { t } = useTranslation();
  const history = useHistory();
  const [cargandoPage, setCargandoPage] = useState(true);
  // const [listaElementos, setListaElementos] = useState([]);
  // const [modalConfirmarDeshabilitarVisible, setModalConfirmarDeshabilitarVisible] = useState(false);
  // const [modalConfirmarHabilitarVisible, setModalConfirmarHabilitarVisible] = useState(false);
  // const [elementoSelected, setElementoSelected] = useState(null);
  // const [permisos, setPermisos] = useState(null);
  const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(false);
  // const [habilitadoSelected, setHabilitadoSelected] = useState(null);
  const [fechaSelected, setFechaSelected] = useState(moment().format("YYYY-MM-DD"));

  const [rowsData, setRowsData] = useState([]);

  const [processingVisible, setProcessingVisible] = useState(false);
  const [toastVisible, setToastVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("warning"); // "warning" | "success" | "error"
  const [productosModalVisible, setProductosModalVisible] = useState(false);
  const [productosModalItems, setProductosModalItems] = useState([]);
  const [workflowModalVisible, setWorkflowModalVisible] = useState(false);
  const [workflowModalItems, setWorkflowModalItems] = useState([]);
  const [mapModalVisible, setMapModalVisible] = useState(false);
  const [mapModalData, setMapModalData] = useState(null);

  const [rowSelected, setRowSelected] = useState(null);
  const [tieneDetalleProductos, setTieneDetalleProductos] = useState(false);
  const [numeroDocumentoSelected, setNumeroDocumentoSelected] = useState("");

  const [btnBuscar, setBtnBuscar] = useState(false);
  const [btnProductos, setBtnProductos] = useState(false);
  const [btnWorkflow, setBtnWorkflow] = useState(false);

  useEffect(() => {
    iniciar();
  }, []);

  const iniciar = async () => {
    let tieneAcceso = false;
    try {
      let objEnviar = {};
      objEnviar.fechaEntrega = moment().format("YYYY-MM-DD");
      if (idTipoUsuarioWeb === STRING_SUPER_ADMIN) {
        tieneAcceso = true;
        setBtnBuscar(true);
        setBtnProductos(true);
        setBtnWorkflow(true);
      }
      if (idTipoUsuarioWeb !== STRING_SUPER_ADMIN) {
        const idRolUsuarioWeb = localStorage.getItem(STRING_ID_ROL_USUARIO_WEB);
        objEnviar.idRolUsuarioWeb = idRolUsuarioWeb;
        const response = await obtenerPermisoRolUsuarioWeb(objEnviar);
        if (response.error === false && response.data !== undefined) {
          const permisos = JSON.parse(response.data.permisos);
          // console.log('permisos');
          // console.log(permisos);
          if (Array.isArray(permisos) && permisos.length > 0) {
            const manage = permisos.find(p => p.id === 6);
            if (manage !== undefined && manage !== null) {
              const permisosPage = manage.subMenu.find(p => p.value === PAGE_ID.SEGUIMIENTO_GRILLA);
              // console.log('permisosPage');
              // console.log(permisosPage);
              tieneAcceso = permisosPage.checked;
              if (tieneAcceso === false) {
                return;
              }
              const permisoBtnBuscar = permisosPage.acciones.find(a => a.value === 'btn_buscar');
              const permisoBtnProductos = permisosPage.acciones.find(a => a.value === 'btn_workflow');
              const permisoBtnWorkflow = permisosPage.acciones.find(a => a.value === 'btn_workflow');
              setBtnBuscar(permisoBtnBuscar?.checked);
              setBtnProductos(permisoBtnProductos?.checked);
              setBtnWorkflow(permisoBtnWorkflow?.checked);
            }
          }
        }
      }
      if (tieneAcceso === true) {
        const response = await obtenerListaDetallePedido(objEnviar, t);
        // console.log("response");
        // console.log(response);
        if (response.error === false) {
          setRowsData(response.data);
        }
        if (response.error === true) {
          showToast(response.message, "error", 3000);
        }
      }
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
    } finally {
      setCargandoPage(false);
      setTieneAccesoAlModulo(tieneAcceso);
    }
  };

  useEffect(() => {
    const $ = window.$ || window.jQuery;
    if (!$) return;
    if (typeof $.fn.dxDataGrid !== "function") return;

    const el = document.getElementById("gridContainer");
    if (!el) return;

    const $el = $(el);

    const opts = {
      dataSource: rowsData,
      paging: {
        pageSize: 20,
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [50, 100, 150, 200],
      },
      remoteOperations: false,
      groupPanel: { visible: true },
      grouping: {
        autoExpandAll: false,
      },
      allowColumnReordering: true,
      rowAlternationEnabled: true,
      showBorders: true,
      columnAutoWidth: true,
      filterRow: {
        visible: true,
        applyFilter: "auto",
      },
      searchPanel: {
        visible: true,
        width: 240,
        placeholder: t("grilla_placeholderbuscar"),
      },
      export: {
        enabled: true,
      },
      headerFilter: {
        visible: true,
      },
      columns: [
        {
          dataField: "acciones",
          caption: t("column_acciones"),
          width: 200,
          allowFiltering: false,
          allowSorting: false,
          cellTemplate: function (container, options) {
            // console.log("cellTemplate acciones");
            // console.log('options', options);
            // console.log('options.data', options.data);
            const buttonContainer = $("<div>").addClass("flex gap-2");

            if (btnProductos === true) {
              $("<button>")
                .addClass(
                  "px-3 py-1 bg-blue-500 hover:bg-blue-600 text-white rounded text-sm"
                )
                .text(t("btn_productos"))
                .on("click", function () {
                  verProductos(options.data);
                })
                .appendTo(buttonContainer);
            }

            if (btnWorkflow === true) {
              $("<button>")
                .addClass(
                  "px-3 py-1 bg-green-500 hover:bg-green-600 text-white rounded text-sm"
                )
                .text(t("btn_workflow"))
                .on("click", function () {
                  verWorkflow(options.data);
                })
                .appendTo(buttonContainer);
            }

            buttonContainer.appendTo(container);
          },
        },
        {
          dataField: "idDetallePedido",
          caption: "ID",
          visible: false,
        },
        {
          dataField: "valuePlaca",
          caption: t("column_placa"),
          visible: false,
        },
        {
          dataField: "labelPlaca",
          caption: t("column_placa"),
          visible: true,
        },
        {
          dataField: "numeroDocumento",
          caption: t("column_numero_documento"),
          width: 200,
        },
        {
          dataField: "tipoServicio",
          caption: t("column_tipo_servicio"),
          width: 200,
        },
        {
          dataField: "estadoPago",
          caption: t("column_estado_pago"),
          width: 200,
        },
        {
          dataField: "idCliente",
          caption: t("column_id_cliente"),
          width: 200,
          visible: false,
        },
        {
          dataField: "cliente",
          caption: t("column_cliente"),
          width: 200,
        },
        {
          dataField: "coordenadasCliente",
          caption: t("column_coordenadas_cliente"),
          width: 200,
        },
        // {
        //   dataField: "longitudCliente",
        //   caption: t("column_longitud_cliente"),
        //   width: 200,
        // },
        {
          dataField: "geocerca",
          caption: t("column_geocerca"),
          width: 200,
        },
        // {
        //   dataField: "idEstadoPendiente",
        //   caption: t("column_id_estado_pendiente"),
        //   width: 200,
        //   visible: false,
        // },
        // {
        //   dataField: "estadoPendiente",
        //   caption: t("column_estado_pendiente"),
        //   width: 200,
        // },
        // {
        //   dataField: "idEstadoIniciado",
        //   caption: t("column_id_estado_iniciado"),
        //   width: 200,
        //   visible: false,
        // },
        // {
        //   dataField: "estadoIniciado",
        //   caption: t("column_estado_iniciado"),
        //   width: 200,
        // },
        {
          dataField: "idEstado",
          caption: t("column_id_estado"),
          width: 200,
          visible: false,
        },
        {
          dataField: "estado",
          caption: t("column_estado"),
          width: 200,
        },
        {
          dataField: "idSubEstado",
          caption: t("column_id_sub_estado"),
          width: 200,
          visible: false,
        },
        {
          dataField: "subEstado",
          caption: t("column_sub_estado"),
          width: 200,
        },
        // {
        //   dataField: "coordenadasInicioAtencion",
        //   caption: t("column_coordenadas_inicio_atencion"),
        //   width: 200,
        // },
        // {
        //   dataField: "coordenadasFinAtencion",
        //   caption: t("column_coordenadas_fin_atencion"),
        //   width: 200,
        // },
        {
          dataField: "fechaProcesoWorkflow",
          caption: t("column_fecha_proceso"),
          width: 200,
        },
        {
          dataField: "finalizadoLabel",
          caption: t("column_finalizado"),
          width: 200,
        },
        {
          dataField: "fechaHoraInicioAtencion",
          caption: t("column_fecha_hora_inicio_atencion"),
          width: 200,
        },
        {
          dataField: "fechaHoraFinAtencion",
          caption: t("column_fecha_hora_fin_atencion"),
          width: 200,
        },
        {
          dataField: "nombreConductor",
          caption: t("column_nombre_conductor"),
          width: 200,
        },

      ],
      onCellClick: function (e) {
        if (e.column?.dataField === "geocerca" ||
          e.column?.dataField === "coordenadasCliente"
        ) {
          openModalMap(e);
        }
      },
    };

    const inst = $el.data("dxDataGrid");
    if (inst) {
      inst.option(opts);
    } else {
      $el.dxDataGrid(opts);
    }

    return () => {
      try {
        $el.dxDataGrid("dispose");
      } catch { }
    };
  }, [rowsData]);


  const openModalMap = (e) => {
    const objEnviar = {
      colorCliente: e.data?.colorCliente,
      latitudCliente: e.data?.latitudCliente,
      longitudCliente: e.data?.longitudCliente,
      coordenadasGeocerca: e.data?.coordenadasGeocerca,
      colorGeocerca: e.data?.colorGeocerca,
    };
    setMapModalData(objEnviar);
    setMapModalVisible(true);
  };

  const verProductos = (data) => {
    try {
      // console.log('verProductos');
      // console.log(data);
      let detalleProductos = false;
      if (Array.isArray(data?.detalleEntregaProducto) && data?.detalleEntregaProducto.length > 0) {
        detalleProductos = true;
      }
      setTieneDetalleProductos(detalleProductos);
      // console.log('detalleProductos');
      // console.log(detalleProductos);
      if (detalleProductos === true) {
        const detalle = Array.isArray(data?.detalleEntregaProducto) ? data.detalleEntregaProducto : [];
        setProductosModalItems(detalle);
      }
      if (detalleProductos === false) {
        const productos = Array.isArray(data?.productos) ? data.productos : [];
        setProductosModalItems(productos);
      }
      setNumeroDocumentoSelected(data?.numeroDocumento);
      setProductosModalVisible(true);
    } catch (err) {
      console.log("verProductos err");
      console.log(err);
    }
  };

  const verWorkflow = (data) => {
    try {
      // console.log("verWorkflow");
      // console.log(data);
      let workflow = data?.jsonFormularioWorkflow;
      if (typeof workflow === "string") {
        try {
          workflow = JSON.parse(workflow);
        } catch (_) {
          workflow = [];
        }
      }
      const items = Array.isArray(workflow) ? workflow : [];
      setWorkflowModalItems(items);
      setWorkflowModalVisible(true);
      setRowSelected(data);
    } catch (err) {
      console.log("verWorkflow err");
      console.log(err);
    }
  };

  const reset = async () => {
    setCargandoPage(true);
    let objEnviar = {};
    objEnviar.fechaEntrega = fechaSelected;
    const response = await obtenerListaDetallePedido(objEnviar, t);
    // console.log("response");
    // console.log(response);
    if (response.error === false) {
      setRowsData(response.data);
    }
    if (response.error === true) {
      showToast(response.message, "error", 3000);
    }
    setCargandoPage(false);
  };

  const showToast = (message, type = "warning", durationMs = 3000) => {
    setToastMessage(message);
    setToastType(type);
    setToastVisible(true);
    // Auto-hide
    window.clearTimeout(showToast._timer);
    showToast._timer = window.setTimeout(() => {
      setToastVisible(false);
    }, durationMs);
  };

  const render = () => {
    try {
      // console.log('listar correo render');
      if (cargandoPage === true) {
        return cargandoCard();
      }
      if (tieneAccesoAlModulo === false) {
        return sinAccesoCard();
      }
      return (
        <div className="max-w-7xl mx-auto px-4 lg:px-6">
          <div className="flex items-center justify-between py-4">
            <div>
              <div className="flex items-center gap-2">
                {/* <ArrowBack onClick={handleAtrasClick} /> */}
                <h2 className="text-xl font-bold text-gray-900">{t("label_lista_seguimiento")}</h2>
              </div>
              <p className="text-sm text-gray-500">{t("label_administra_la_lista_de_seguimiento")}</p>
            </div>
            <div className="flex items-center gap-2">
              {/* <button
                type="button"
                className={ESTILO_BOTON_LISTAR_NUEVO}
                onClick={() => {
                  handleNuevoClick();
                }}
              >
                {t("label_nuevo")}
              </button> */}
            </div>
          </div>
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
              <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="habilitado">
                {t("label_fecha")}
              </label>
              <Calendar
                value={fechaSelected}
                onChange={(date) => setFechaSelected(date)}
                placeholder={t("placeholder_seleccione_fecha")}
                id="fecha_asignacion"
                name="fecha_asignacion"
              />
            </div>
            {btnBuscar === true && (
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="habilitado">
                  &nbsp;
                </label>
                <button
                  type="button"
                  className={ESTILO_BOTON_MODAL_ACEPTAR}
                  onClick={() => { reset(); }}
                >
                  {t("label_buscar")}
                </button>
              </div>
            )}
          </div>
          <br />
          {/* Grid Card */}
          <div className="bg-white border border-gray-200 rounded-lg p-2">
            <div className="min-h-[400px]">
              <div
                id="gridContainer"
                style={{
                  height: "100%",
                  width: "100%",
                }}
              />
            </div>
          </div>
          <ProductosModal
            visible={productosModalVisible}
            items={productosModalItems}
            onClose={() => setProductosModalVisible(false)}
            tieneDetalleProductos={tieneDetalleProductos}
            numeroDocumento={numeroDocumentoSelected}
          />
          <WorkflowModal
            visible={workflowModalVisible}
            items={workflowModalItems}
            onClose={() => setWorkflowModalVisible(false)}
            t={t}
            rowSelected={rowSelected}
          />
          <ModalMapaSeguimiento
            visible={mapModalVisible}
            mapData={mapModalData}
            onClose={() => {
              setMapModalVisible(false);
              setMapModalData(null);
            }}
          />
          {/* <ModalConfirmar
            isOpen={modalConfirmarDeshabilitarVisible}
            onCancel={() => { setModalConfirmarDeshabilitarVisible(false); }}
            onConfirm={handleConfirmModalDeshabilitar}
            message={sharedMensajeConfirmacion(t("alert_esta_de_deshabilitar"), elementoSelected?.descripcion)}
          />
          <ModalConfirmar
            isOpen={modalConfirmarHabilitarVisible}
            onCancel={() => { setModalConfirmarHabilitarVisible(false); }}
            onConfirm={handleConfirmHabilitarModal}
            message={sharedMensajeConfirmacion(t("alert_esta_de_habilitar"), elementoSelected?.descripcion)}
          /> */}
          <ProcessingDialog visible={processingVisible} message={t("alert_procesando_solicitud")} />
          <ToastComponent
            visible={toastVisible}
            message={toastMessage}
            type={toastType}
            onClose={() => setToastVisible(false)}
          />
        </div>
      );
    } catch (err) {
      console.log('ListarCliente render err');
      console.log(err);
      return (
        <div><label>{JSON.stringify(err)}</label></div>
      );
    }
  }

  return render();
}
